export default {"src":"/_next/static/media/dollar_banknote_color.984d910b.svg","height":32,"width":32};